import { useCallback, useEffect, useMemo, useState } from "react";
import { getLideres } from "../Api/ApiMetodo";
import { guardarCache, leerCache } from "../utils/almacenLocal";
import { esErrorDeRed } from "../utils/colaSincronizacion";

const CLAVE_LIDERES = "catalogos:lideres";

// Líderes ya registrados (de todos los electores) como opciones de
// SelectComponent. Sin conexión usa la última copia guardada en el equipo.
const useLideres = () => {
  const [lideres, setLideres] = useState([]);

  const recargar = useCallback(async () => {
    try {
      const lista = await getLideres();
      setLideres(lista);
      guardarCache(CLAVE_LIDERES, lista);
    } catch (error) {
      if (!esErrorDeRed(error)) {
        console.error(error);
        return;
      }
      setLideres((await leerCache(CLAVE_LIDERES)) ?? []);
    }
  }, []);

  useEffect(() => {
    recargar();
  }, [recargar]);

  const opcionesLider = useMemo(() => lideres.map((lider) => ({ value: lider, label: lider })), [lideres]);

  return { lideres, opcionesLider, recargar };
};

export default useLideres;
